export default __webpack_public_path__ + "static/media/2420.4589bdda.png";